module.exports = __webpack_public_path__ + "img/s2P2.dd0b86e5.png";